'use client';
"use strict";

exports.__esModule = true;
exports.RSUITE_PICKER_GROUP_KEY = exports.RSUITE_PICKER_TYPE = void 0;
var RSUITE_PICKER_TYPE = Symbol.for('rsuite.picker');
exports.RSUITE_PICKER_TYPE = RSUITE_PICKER_TYPE;
var RSUITE_PICKER_GROUP_KEY = Symbol.for('rsuite.picker_group_key');
exports.RSUITE_PICKER_GROUP_KEY = RSUITE_PICKER_GROUP_KEY;